
export enum ApiContractStatusCd {
	ARCHIVED = 'Archived',
	CANCELLED = 'Cancelled',
	IMPLEMENTED = 'Implemented',
	PENDING = 'Pending',
	SAVED = 'Saved'}

